import { isAuthorised } from '../../store/auth/token';
import { authRoles } from '../../router/roleGroups';

export const isSharedListAdmin = () => isAuthorised(authRoles.shared.SharedListAdmin);

export const canEditSharedLists = () => isSharedListAdmin();

export const canEditSharedTaxRollSummary = () => isAuthorised(authRoles.SuperAdmin);

export default {
  isSharedListAdmin,
  canEditSharedLists,
  canEditSharedTaxRollSummary,
};
